import { render, staticRenderFns } from "./InsLocation.vue?vue&type=template&id=54a8dc26&scoped=true"
import script from "./InsLocation.vue?vue&type=script&lang=ts"
export * from "./InsLocation.vue?vue&type=script&lang=ts"
import style0 from "./InsLocation.vue?vue&type=style&index=0&id=54a8dc26&prod&lang=css"
import style1 from "./InsLocation.vue?vue&type=style&index=1&id=54a8dc26&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54a8dc26",
  null
  
)

export default component.exports